import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" * 家紋のベクトルデータは")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  class: "underline",
  href: "http://hakko-daiodo.com"
}, "発行大王堂様", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("よりご提供いただいています。 ")
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" *All Kamon vector data were provided by ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  class: "underline",
  href: "http://hakko-daiodo.com"
}, "Hakko Daiodo", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.lang === 'ja')
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _hoisted_5))
      : (_openBlock(), _createElementBlock("p", _hoisted_6, _hoisted_10))
  ]))
}